/** Ids of the questions that exist on the server (unsaved ones have none), in the order given. */
export const savedQuestionIds = (questions: { id?: number | string | null }[]): number[] =>
  questions.map((q) => Number(q.id)).filter((id) => id > 0);

/** The list with the item at `index` swapped with its neighbour, or null when it can't move that way. */
export const moveItem = <T>(items: T[], index: number, delta: -1 | 1): T[] | null => {
  const target = index + delta;
  if (index < 0 || index >= items.length || target < 0 || target >= items.length) return null;
  const moved = [...items];
  [moved[index], moved[target]] = [moved[target], moved[index]];
  return moved;
};

export const sameOrder = (a: number[], b: number[]) => a.length === b.length && a.every((x, i) => x === b[i]);
